export const SET_AUTH_JWT = "SET_AUTH_JWT";
export const REMOVE_AUTH_JWT = "REMOVE_AUTH_JWT";
export const ADD_CURRENT_USER = "ADD_CURRENT_USER";
export const REMOVE_CURRENT_USER = "REMOVE_CURRENT_USER";
export const EDIT_CURRENT_USER = "EDIT_CURRENT_USER";
